import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { NFLookupVendorCustomer } from "src/components/Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "src/components/Shared/NewForms/NFLookupContract";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import { NFLookupBankAccountVendorCustomer } from "src/components/Shared/NewForms/NFLookupBankAccountVendorCustomer";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";

const PaymentRequestOperationTypesIssuanceOfLoanDetail = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} />
        </Col>
        <Col sm={6}>
          <NFLookupContract fieldName="contractId" title={t("Contract")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
        </Col>
        <Col sm={6}>
          <NFLookupCashRegister fieldName="cashAccountId" title={t("CashAccount")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccountVendorCustomer fieldName="payerAccountId" title={t("PayerAccount")} />
        </Col>
        <Col sm={6}>
          <NFLookupCashRegister fieldName="moneyReceivingCashAccountId" title={t("MoneyReceivingCashAccount")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput title={t("Amount")} fieldName={"amount"} required />
        </Col>
        <Col sm={6}>
          <NFIntInput fieldName={"amountWithVat"} title={t("InTheAmountOf")} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency fieldName={"convertedCurrencyId"} title={t("ConvertedCurrency")} required />
        </Col>
      </Row>
    </>
  );
};

export default PaymentRequestOperationTypesIssuanceOfLoanDetail;
